export const macroAssetTypes = {
  SEC: 'Securities',
  DER: 'Derivatives',
  PHY: 'Physical',
  CIU: 'Collective Investment Undertaking',
  OTH: 'Other Assets'
};

export const assetTypes = {
  SEC_CSH: 'Cash and cash equivalent',
  SEC_LEQ: 'Listed equities',
  SEC_UEQ: 'Unlisted equities',
  SEC_CPN: 'Corporate bonds not issued by financial institutions',
  SEC_CPI: 'Corporate bonds issued by financial institutions',
  SEC_SBD: 'Sovereign bonds',
  SEC_MBN: 'Municipal bonds',
  SEC_CBN: 'Convertible bonds not issued by financial institutions',
  SEC_CBI: 'Convertible bonds issued by financial institutions',
  SEC_LON: 'Loans',
  SEC_SSP: 'Structured/securitised products',
  DER_EQD: 'Equity derivatives',
  DER_FID: 'Fixed income derivatives',
  DER_CDS: 'CDS',
  DER_FEX: 'FX exposures',
  DER_IRD: 'Interest rate derivatives',
  DER_CTY: 'Energy',
  DER_OTH: 'Other derivatives',
  PHY_RES: 'Physical: real estate',
  PHY_CTY: 'Physical: Commodities',
  PHY_TIM: 'Physical: Timber',
  PHY_ART: 'Physical: Art and collectables',
  PHY_TPT: 'Physical: Transportation assets',
  PHY_OTH: 'Physical: Other',
  CIU_OAM: 'Investment in CIU operated/managed by the AIFM',
  CIU_NAM: 'Investment in CIU not operated/managed by the AIFM',
  OTH_OTH: 'Total Other'
};

export const subAssetTypesFCA = {
  SEC_CSH_CODP: 'Certificates of deposit',
  SEC_CSH_COMP: 'Commercial papers',
  SEC_CSH_OTHD: 'Other deposits',
  SEC_CSH_OTHC: 'Other cash and cash equivalents (excluding government securities)',
  SEC_LEQ_IFIN: 'Listed equities issued by financial institutions',
  SEC_LEQ_OTHR: 'Other listed equity',
  SEC_UEQ_UEQY: 'Unlisted equities',
  SEC_CPN_INVG: 'Investment grade',
  SEC_CPN_NIVG: 'Non-investment grade',
  SEC_CPI_INVG: 'Investment grade',
  SEC_CPI_NIVG: 'Non-investment grade',
  SEC_SBD_UKBY: 'UK bonds with a 0-1 year term to maturity',
  SEC_SBD_UKBM: 'UK bonds with a 1+ year term to maturity',
  SEC_SBD_EUGY: 'G10 bonds with a 0-1 year term to maturity',
  SEC_SBD_EUGM: 'G10 bonds with a 1+ year term to maturity',
  SEC_SBD_NOGY: 'Non-G10 bonds with a 0-1 year term to maturity',
  SEC_SBD_NOGM: 'Non-G10 bonds with a 1+ year term to maturity',
  SEC_MBN_MNPL: 'Municipal bonds',
  SEC_CBN_INVG: 'Investment grade',
  SEC_CBN_NIVG: 'Non-investment grade',
  SEC_CBI_INVG: 'Investment grade',
  SEC_CBI_NIVG: 'Non-investment grade',
  SEC_LON_LEVL: 'Leveraged loans',
  SEC_LON_OTHL: 'Other loans',
  SEC_SSP_SABS: 'ABS',
  SEC_SSP_RMBS: 'RMBS',
  SEC_SSP_CMBS: 'CMBS',
  SEC_SSP_AMBS: 'Agency MBS',
  SEC_SSP_ABCP: 'ABCP',
  SEC_SSP_CDOC: 'CDO/CLO',
  SEC_SSP_STRC: 'Structured certificates',
  SEC_SSP_SETP: 'ETP',
  SEC_SSP_OTHS: 'Other',
  DER_EQD_FINI: 'Equity derivatives related to financial institutions',
  DER_EQD_OTHD: 'Other equity derivatives',
  DER_FID_FIXI: 'Fixed income derivatives',
  DER_CDS_SNFI: 'Single name financial CDS',
  DER_CDS_SNSO: 'Single name sovereign CDS',
  DER_CDS_SNOT: 'Single name other CDS',
  DER_CDS_INDX: 'Index CDS',
  DER_CDS_EXOT: 'Exotic (incl. credit default tranche)',
  DER_CDS_OTHR: 'Other CDS',
  DER_FEX_INVT: 'Foreign exchange (for investment purposes)',
  DER_FEX_HEDG: 'Foreign exchange (for hedging purposes)',
  DER_IRD_INTR: 'Interest rate derivatives',
  DER_CTY_ECOL: 'Energy/Crude oil',
  DER_CTY_ENNG: 'Energy/Natural gas',
  DER_CTY_ENPW: 'Energy/Power',
  DER_CTY_ENOT: 'Energy/Other',
  DER_CTY_PMGD: 'Precious metals/Gold',
  DER_CTY_PMOT: 'Precious metals/Other',
  DER_CTY_OTIM: 'Other commodities/Industrial metals',
  DER_CTY_OTLS: 'Other commodities/Livestock',
  DER_CTY_OTAP: 'Other commodities/Agricultural products',
  DER_CTY_OTHR: 'Other commodities/Other',
  DER_OTH_OTHR: 'Other derivatives',
  PHY_RES_RESL: 'Residential real estate',
  PHY_RES_COML: 'Commercial real estate',
  PHY_RES_OTHR: 'Other real estate',
  PHY_CTY_PCTY: 'Physical: Commodities',
  PHY_TIM_PTIM: 'Physical: Timber',
  PHY_ART_PART: 'Physical: Art and collectables',
  PHY_TPT_PTPT: 'Physical: Transportation assets',
  PHY_OTH_OTHR: 'Physical: Other',
  CIU_OAM_MMFC: 'Money market funds and cash management CIU',
  CIU_OAM_AETF: 'ETF',
  CIU_OAM_OTHR: 'Other CIU',
  CIU_NAM_MMFC: 'Money market funds and cash management CIU',
  CIU_NAM_AETF: 'ETF',
  CIU_NAM_OTHR: 'Other CIU',
  OTH_OTH_OTHR: 'Total of other asset classes',
  NTA_NTA_NOTA: 'N/A'
};

export const subAssetTypes = {
  SEC_CSH_CODP: 'Certificates of deposit',
  SEC_CSH_COMP: 'Commercial papers',
  SEC_CSH_OTHD: 'Other deposits',
  SEC_CSH_OTHC: 'Other cash and cash equivalents (excluding government securities)',
  SEC_LEQ_IFIN: 'Listed equities issued by financial institutions',
  SEC_LEQ_OTHR: 'Other listed equity',
  SEC_UEQ_UEQY: 'Unlisted equities',
  SEC_CPN_INVG: 'Investment grade',
  SEC_CPN_NIVG: 'Non-investment grade',
  SEC_CPI_INVG: 'Investment grade',
  SEC_CPI_NIVG: 'Non-investment grade',
  SEC_SBD_UKBY: 'UK bonds with a 0-1 year term to maturity',
  SEC_SBD_UKBM: 'UK bonds with a 1+ year term to maturity',
  SEC_SBD_EUGY: 'G10 bonds with a 0-1 year term to maturity',
  SEC_SBD_EUGM: 'G10 bonds with a 1+ year term to maturity',
  SEC_SBD_NOGY: 'Non-G10 bonds with a 0-1 year term to maturity',
  SEC_SBD_NOGM: 'Non-G10 bonds with a 1+ year term to maturity',
  SEC_MBN_MNPL: 'Municipal bonds',
  SEC_CBN_INVG: 'Investment grade',
  SEC_CBN_NIVG: 'Non-investment grade',
  SEC_CBI_INVG: 'Investment grade',
  SEC_CBI_NIVG: 'Non-investment grade',
  SEC_LON_LEVL: 'Leveraged loans',
  SEC_LON_OTHL: 'Other loans',
  SEC_SSP_SABS: 'ABS',
  SEC_SSP_RMBS: 'RMBS',
  SEC_SSP_CMBS: 'CMBS',
  SEC_SSP_AMBS: 'Agency MBS',
  SEC_SSP_ABCP: 'ABCP',
  SEC_SSP_CDOC: 'CDO/CLO',
  SEC_SSP_STRC: 'Structured certificates',
  SEC_SSP_SETP: 'ETP',
  SEC_SSP_OTHS: 'Other',
  DER_EQD_FINI: 'Equity derivatives related to financial institutions',
  DER_EQD_OTHD: 'Other equity derivatives',
  DER_FID_FIXI: 'Fixed income derivatives',
  DER_CDS_SNFI: 'Single name financial CDS',
  DER_CDS_SNSO: 'Single name sovereign CDS',
  DER_CDS_SNOT: 'Single name other CDS',
  DER_CDS_INDX: 'Index CDS',
  DER_CDS_EXOT: 'Exotic (incl. credit default tranche)',
  DER_CDS_OTHR: 'Other CDS',
  DER_FEX_INVT: 'Foreign exchange (for investment purposes)',
  DER_FEX_HEDG: 'Foreign exchange (for hedging purposes)',
  DER_IRD_INTR: 'Interest rate derivatives',
  DER_CTY_ECOL: 'Energy/Crude oil',
  DER_CTY_ENNG: 'Energy/Natural gas',
  DER_CTY_ENPW: 'Energy/Power',
  DER_CTY_ENOT: 'Energy/Other',
  DER_CTY_PMGD: 'Precious metals/Gold',
  DER_CTY_PMOT: 'Precious metals/Other',
  DER_CTY_OTIM: 'Other commodities/Industrial metals',
  DER_CTY_OTLS: 'Other commodities/Livestock',
  DER_CTY_OTAP: 'Other commodities/Agricultural products',
  DER_CTY_OTHR: 'Other commodities/Other',
  DER_OTH_OTHR: 'Other derivatives',
  PHY_RES_RESL: 'Residential real estate',
  PHY_RES_COML: 'Commercial real estate',
  PHY_RES_OTHR: 'Other real estate',
  PHY_CTY_PCTY: 'Physical: Commodities',
  PHY_TIM_PTIM: 'Physical: Timber',
  PHY_ART_PART: 'Physical: Art and collectables',
  PHY_TPT_PTPT: 'Physical: Transportation assets',
  PHY_OTH_OTHR: 'Physical: Other',
  CIU_OAM_MMFC:
    'Investment in CIU operated/managed by the AIFM-Money Market Funds and cash management CIU',
  CIU_OAM_AETF: 'Investment in CIU operated/managed by the AIFM-ETF',
  CIU_OAM_OTHR: 'Investment in CIU operated/managed by the AIFM-Other CIU',
  CIU_NAM_MMFC:
    'Investment in CIU not operated/managed by the AIFM-Money Market Funds and cash management CIU',
  CIU_NAM_AETF: 'Investment in CIU not operated/managed by the AIFM-ETF',
  CIU_NAM_OTHR: 'Investment in CIU not operated/managed by the AIFM-Other CIU',
  OTH_OTH_OTHR: 'Total Other',
  NTA_NTA_NOTA: 'N/A'
};

export const subAssetTypeFields = {
  SEC_CSH_CODP: { long_value: null, short_value: null },
  SEC_CSH_COMP: { long_value: null, short_value: null },
  SEC_CSH_OTHD: { long_value: null, short_value: null },
  SEC_CSH_OTHC: { long_value: null, short_value: null },
  SEC_LEQ_IFIN: { long_value: null, short_value: null },
  SEC_LEQ_OTHR: { long_value: null, short_value: null },
  SEC_UEQ_UEQY: { long_value: null, short_value: null },
  SEC_CPN_INVG: { long_value: null, short_value: null },
  SEC_CPN_NIVG: { long_value: null, short_value: null },
  SEC_CPI_INVG: { long_value: null, short_value: null },
  SEC_CPI_NIVG: { long_value: null, short_value: null },
  SEC_SBD_UKBY: { long_value: null, short_value: null },
  SEC_SBD_UKBM: { long_value: null, short_value: null },
  SEC_SBD_NOGY: { long_value: null, short_value: null },
  SEC_SBD_NOGM: { long_value: null, short_value: null },
  SEC_SBD_EUGY: { long_value: null, short_value: null },
  SEC_SBD_EUGM: { long_value: null, short_value: null },
  SEC_MBN_MNPL: { long_value: null, short_value: null },
  SEC_CBN_INVG: { long_value: null, short_value: null },
  SEC_CBN_NIVG: { long_value: null, short_value: null },
  SEC_CBI_INVG: { long_value: null, short_value: null },
  SEC_CBI_NIVG: { long_value: null, short_value: null },
  SEC_LON_LEVL: { long_value: null, short_value: null },
  SEC_LON_OTHL: { long_value: null, short_value: null },
  SEC_SSP_SABS: { long_value: null, short_value: null },
  SEC_SSP_RMBS: { long_value: null, short_value: null },
  SEC_SSP_CMBS: { long_value: null, short_value: null },
  SEC_SSP_AMBS: { long_value: null, short_value: null },
  SEC_SSP_ABCP: { long_value: null, short_value: null },
  SEC_SSP_CDOC: { long_value: null, short_value: null },
  SEC_SSP_STRC: { long_value: null, short_value: null },
  SEC_SSP_SETP: { long_value: null, short_value: null },
  SEC_SSP_OTHS: { long_value: null, short_value: null },
  DER_EQD_FINI: { long_value: null, short_value: null },
  DER_EQD_OTHD: { long_value: null, short_value: null },
  DER_FID_FIXI: { long_value: null, short_value: null },
  DER_CDS_SNFI: { long_value: null, short_value: null },
  DER_CDS_SNSO: { long_value: null, short_value: null },
  DER_CDS_SNOT: { long_value: null, short_value: null },
  DER_CDS_INDX: { long_value: null, short_value: null },
  DER_CDS_EXOT: { long_value: null, short_value: null },
  DER_CDS_OTHR: { long_value: null, short_value: null },
  DER_FEX_INVT: { gross_value: null },
  DER_FEX_HEDG: { gross_value: null },
  DER_IRD_INTR: { gross_value: null },
  DER_CTY_ECOL: { long_value: null, short_value: null },
  DER_CTY_ENNG: { long_value: null, short_value: null },
  DER_CTY_ENPW: { long_value: null, short_value: null },
  DER_CTY_ENOT: { long_value: null, short_value: null },
  DER_CTY_PMGD: { long_value: null, short_value: null },
  DER_CTY_PMOT: { long_value: null, short_value: null },
  DER_CTY_OTIM: { long_value: null, short_value: null },
  DER_CTY_OTLS: { long_value: null, short_value: null },
  DER_CTY_OTAP: { long_value: null, short_value: null },
  DER_CTY_OTHR: { long_value: null, short_value: null },
  DER_OTH_OTHR: { long_value: null, short_value: null },
  PHY_RES_RESL: { long_value: null, short_value: null },
  PHY_RES_COML: { long_value: null, short_value: null },
  PHY_RES_OTHR: { long_value: null, short_value: null },
  PHY_CTY_PCTY: { long_value: null, short_value: null },
  PHY_TIM_PTIM: { long_value: null, short_value: null },
  PHY_ART_PART: { long_value: null, short_value: null },
  PHY_TPT_PTPT: { long_value: null, short_value: null },
  PHY_OTH_OTHR: { long_value: null, short_value: null },
  CIU_OAM_MMFC: { long_value: null, short_value: null },
  CIU_OAM_AETF: { long_value: null, short_value: null },
  CIU_OAM_OTHR: { long_value: null, short_value: null },
  CIU_NAM_MMFC: { long_value: null, short_value: null },
  CIU_NAM_AETF: { long_value: null, short_value: null },
  CIU_NAM_OTHR: { long_value: null, short_value: null },
  OTH_OTH_OTHR: { long_value: null, short_value: null },
  NTA_NTA_NOTA: { long_value: null, short_value: null }
};

export const turnoverAssetTypesFCA = {
  SEC_CSH_CSH: 'Cash and cash equivalents',
  SEC_LEQ_LEQ: 'Listed equities',
  SEC_UEQ_UEQ: 'Unlisted equities',
  SEC_CPN_IVG: 'Corporate bonds not issued by financial institutions-Investment grade',
  SEC_CPN_NIG: 'Corporate bonds not issued by financial institutions-Non-investment grade',
  SEC_CPI_CPI: 'Corporate bonds issued by financial institutions',
  SEC_SBD_UKB: 'UK bonds',
  SEC_SBD_NUK: 'Non-UK bonds',
  SEC_MUN_MUN: 'Municipal bonds',
  SEC_CBD_CBD: 'Convertible bonds',
  SEC_LON_LON: 'Loans',
  SEC_SSP_SSP: 'Structured/securitised products',
  DER_EQD_EQD: 'Equity derivatives',
  DER_FID_FID: 'Fixed income derivatives',
  DER_CDS_CDS: 'CDS',
  DER_FEX_INV: 'Foreign exchange (for investment purposes)',
  DER_FEX_HED: 'Foreign exchange (for hedging purposes)',
  DER_IRD_IRD: 'Interest rate derivatives',
  DER_CTY_CTY: 'Commodity derivatives',
  DER_OTH_OTH: 'Other derivatives',
  PHY_RES_RES: 'Physical: Real estate',
  PHY_CTY_CTY: 'Physical: Commodities',
  PHY_TIM_TIM: 'Physical: Timber',
  PHY_ART_ART: 'Physical: Art and collectables',
  PHY_TPT_TPT: 'Physical: Transportation assets',
  PHY_OTH_OTH: 'Physical: Other',
  CIU_CIU_CIU: 'Collective Investment Undertakings',
  OTH_OTH_OTH: 'Total Other'
};

export const turnoverAssetTypes = {
  SEC_CSH_CSH: 'Cash and cash equivalents',
  SEC_LEQ_LEQ: 'Listed equities',
  SEC_UEQ_UEQ: 'Unlisted equities',
  SEC_CPN_IVG: 'Corporate bonds not issued by financial institutions-Investment grade',
  SEC_CPN_NIG: 'Corporate bonds not issued by financial institutions-Non-investment grade',
  SEC_CPI_CPI: 'Corporate bonds issued by financial institutions',
  SEC_SBD_UKB: 'Sovereign bonds - UK bonds',
  SEC_SBD_NUK: 'Sovereign bonds - UK bonds',
  SEC_MUN_MUN: 'Municipal bonds',
  SEC_CBD_CBD: 'Convertible bonds',
  SEC_LON_LON: 'Loans',
  SEC_SSP_SSP: 'Structured/securitised products',
  DER_EQD_EQD: 'Equity derivatives',
  DER_FID_FID: 'Fixed income derivatives',
  DER_CDS_CDS: 'CDS',
  DER_FEX_INV: 'Foreign exchange (for investment purposes)',
  DER_FEX_HED: 'Foreign exchange (for hedging purposes)',
  DER_IRD_IRD: 'Interest rate derivatives',
  DER_CTY_CTY: 'Commodity derivatives',
  DER_OTH_OTH: 'Other derivatives',
  PHY_RES_RES: 'Physical: Real estate',
  PHY_CTY_CTY: 'Physical: Commodities',
  PHY_TIM_TIM: 'Physical: Timber',
  PHY_ART_ART: 'Physical: Art and collectables',
  PHY_TPT_TPT: 'Physical: Transportation assets',
  PHY_OTH_OTH: 'Physical: Other',
  CIU_CIU_CIU: 'Collective Investment Undertakings',
  OTH_OTH_OTH: 'Total Other'
};

export const stickyTopRowTableNames = [
  'ASSUMPTIONS',
  'CURRENCIES',
  'DOMINANT_INFLUENCES',
  'HEADER_SECTION',
  'FUND_ID_CODES',
  'PORTFOLIO_LIQUIDITY_PROFILE',
  'INVESTOR_LIQUIDITY_PROFILE',
  'MAIN_INSTRUMENTS',
  'MASTER_AIF',
  'PRIME_BROKE_FUNDS',
  'SHARE_CLASSES',
  'HEDGE_STRATEGIES',
  'PRIVATE_EQUITY_STRATEGIES',
  'REAL_ESTATE_STRATEGIES',
  'FUND_OF_FUND_STRATEGIES',
  'OTHER_FUND_STRATEGIES'
];
